
// import Swiper from 'swiper';
// import SwiperCore, { Navigation, Pagination } from 'swiper/core';

class Termekajanlo2024 {

    constructor() {

        this.carouselBrakepoints = {
            380: {
                spaceBetween: 0,
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            580: {
                spaceBetween: 15,
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            980: {
                spaceBetween: 15,
                slidesPerView: 5,
                slidesPerGroup: 5
            },
            1200: {
                spaceBetween: 15,
                slidesPerView: 5,
                slidesPerGroup: 5
            }
        };
        this.init();
    }

    init() {

        if ($('.termekajanlo-cimlap-2024').length > 0) {

            $.each($('.termekajanlo-cimlap-2024'), (ii, tItem) => {

                let baseID = $(tItem).attr('id').replace('instance_', '');

                this.basePanel = $('#' + baseID);

                this.initCarousel(baseID)
            });
        }
    }

    initCarousel(baseID) {
        setTimeout(() => {
            if ($('.termekajanlo-cimlap-2024#instance_' + baseID + ' .carousel-strip').length > 0) {

                let isVasarlas = false;
                let isCimlap = false;
                let isReceptoldal = false;

                if ($('.termekajanlo-cimlap-2024#instance_' + baseID).hasClass('vasarlas')) {
                    isVasarlas = true;
                }

                if ($('.termekajanlo-cimlap-2024#instance_' + baseID).hasClass('cimlap')) {
                    isCimlap = true;
                }

                if ($('.termekajanlo-cimlap-2024#instance_' + baseID).hasClass('receptoldal')) {
                    isReceptoldal = true;
                }

                $('.termekajanlo-cimlap-2024#instance_' + baseID + ' .carousel-strip-wrapper').css(
                    'width',
                    (window.innerWidth - $('.termekajanlo-cimlap-2024#instance_' + baseID + ' .carousel-wrap').offset().left) + 'px'
                );
                let extraStr = 'onlyitems|termekajanlo2024';
                if (isVasarlas) {
                    extraStr = 'onlyitems|termekajanlo2024|vasarlas';
                }

                if (isCimlap) {
                    extraStr += '|cimlap';
                }

                if (isReceptoldal) {
                    extraStr += '|receptoldal';
                }

                if (window.keresoCSRFToken !== undefined) {
                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-Token': window.keresoCSRFToken
                        }
                    });
                }

                let ajaxParams = {
                    limit: 12,
                    kategoria: -2,
                    extra: extraStr,
                    randomorder: 1,
                    t: (new Date().getTime())
                };

                if (isReceptoldal && window.podorReceptTermekIds && window.podorReceptTermekIds.length > 0) {
                    ajaxParams.termekids = window.podorReceptTermekIds.join(',');
                }

                $.get('/index.php/webshoplist_static/gethtml',
                    ajaxParams, (res) => {

                        $('.termekajanlo-cimlap-2024#instance_' + baseID + ' .carousel-strip').empty().append(res.html);


                        $('.termekajanlo-cimlap-2024#instance_' + baseID + ' .clickable').each(function () {
                            if ($(this).data('url') != "") {
                                $(this).on('click', function () {
                                    document.location.href = $(this).data('url');
                                });
                            }
                        });

                        new Swiper('.termekajanlo-cimlap-2024#instance_' + baseID + ' .carousel-strip-wrapper', {
                            slidesPerView: 'auto',
                            // slidesPerGroup: 1,
                            spaceBetween: 24,
                            watchOverflow: false,
                            scrollbar: {
                                enabled: true,
                                el: '.termekajanlo-cimlap-2024#instance_' + baseID + ' .swiper-scrollbar',
                                hide: false,
                            },
                            loop: true,
                            // autoplay: {
                            //     delay: 7000
                            // },
                            // breakpoints: this.carouselBrakepoints,
                            navigation: {
                                nextEl: '.termekajanlo-cimlap-2024#instance_' + baseID + ' .carousel-control .control-right',
                                prevEl: '.termekajanlo-cimlap-2024#instance_' + baseID + ' .carousel-control .control-left',
                            }
                        });

                    });
            }
        }, 1000);
    }

}

export default Termekajanlo2024;

